import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'ksnm-common-ui/lib/Icon';

import { Row } from '@common/Row';
import { dataControlStore } from '@stores/dataControlStore';

import { GoPreparationOfReportsButton } from '../../GoPreparationOfReportsButton';

import styles from './Title.module.scss';

interface IData {
  report_package_code_cm?: string;
  status_out?: string;
}

export const Title = observer(({ data }: { data: IData }) => {
  const { setInfoDrawer, lastPagesParam } = dataControlStore;

  return (
    <>
      <p className={styles.title}>Контроли: уровень пакета</p>

      <div className={styles.info}>
        <Row
          name="Код пакета:"
          value={
            <div className={styles.package}>
              {data.report_package_code_cm ?? ''} <Icon name="info" />{' '}
              <GoPreparationOfReportsButton packageCode={lastPagesParam.reportPackageCodeCm} />
            </div>
          }
          onClick={() => setInfoDrawer({ packageCode: lastPagesParam.reportPackageCodeCm })}
          nameWidth={230}
        />
        <Row name="Общий статус прохождения КП: " value={data.status_out} nameWidth={230} />
      </div>
    </>
  );
});
